import { GraduationCap, Award, Users } from "lucide-react";

const HERO_BG =
    "https://images.pexels.com/photos/31070800/pexels-photo-31070800.jpeg";

export const Hero = () => (
    <section
        id="home"
        data-testid="hero-section"
        className="relative min-h-[100svh] w-full flex items-end overflow-hidden"
    >
        <img
            src={HERO_BG}
            alt="Campus"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="grain absolute inset-0" />

        <div className="relative z-10 max-w-7xl mx-auto w-full px-5 md:px-8 lg:px-12 pb-20 md:pb-28 pt-32">
            <div className="max-w-3xl">
                <span
                    data-testid="hero-eyebrow"
                    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur text-white/90 text-xs tracking-[0.2em] uppercase reveal"
                >
                    <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-yellow)]" />
                    A Unit of Prasad Educational Trust
                </span>

                <h1
                    data-testid="hero-title"
                    className="font-display text-white mt-6 reveal delay-1 text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] font-medium"
                >
                    Prasad Rudrik <br />
                    <span className="italic text-[var(--brand-yellow)]">College of </span>
                    <br className="hidden md:block" />
                    Pharmaceutical Sciences
                </h1>

                <p
                    data-testid="hero-subtitle"
                    className="text-white/85 mt-7 max-w-xl text-base md:text-lg leading-relaxed reveal delay-2"
                >
                    Shaping tomorrow&rsquo;s healthcare leaders through a rigorous, hands-on
                    pharmacy education in Birbhum, West Bengal — where compassion meets
                    competence.
                </p>

                <div className="mt-10 flex flex-wrap items-center gap-4 reveal delay-3">
                    <a href="#admission" data-testid="hero-apply-cta" className="btn-accent">
                        Apply for D.Pharm
                        <i className="fa-solid fa-arrow-right text-xs" />
                    </a>
                    <a href="#course" data-testid="hero-explore-cta" className="btn-ghost">
                        Explore the Course
                    </a>
                </div>

                <div className="mt-14 grid grid-cols-3 gap-4 md:gap-8 max-w-xl reveal delay-4">
                    {[
                        { icon: GraduationCap, k: "60", v: "Seats / Year" },
                        { icon: Award, k: "2yr", v: "D.Pharm Diploma" },
                        { icon: Users, k: "10+", v: "Career Tracks" },
                    ].map(({ icon: Icon, k, v }) => (
                        <div key={v} className="text-white" data-testid={`hero-stat-${v.toLowerCase().replace(/\s+/g, "-")}`}>
                            <Icon size={22} className="text-[var(--brand-yellow)] mb-2" />
                            <div className="font-display text-3xl md:text-4xl font-medium">{k}</div>
                            <div className="text-xs md:text-sm text-white/70 tracking-wide uppercase">{v}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-white/70 text-xs tracking-[0.2em] uppercase float-anim">
            <span className="w-12 h-px bg-white/40" />
            Scroll
        </div>
    </section>
);

export default Hero;
